import TermsOfService, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/termsofservice';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default TermsOfService;
